module.exports = __webpack_public_path__ + "static/media/veterinaria.4be2ed94.jpg";